import InvoicePageGroup from 'source/pages/root/InvoicePageGroup.vue';

export default [{
    path: 'invoices',
    component: InvoicePageGroup,
    meta: {
        title: 'Invoices - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: '',
            name: 'invoices',
            component: () => import('src/pages/client/InvoicesPage.vue'),
            meta: {
                title: 'Invoices - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        }, {
            path: 'invoice-details',
            name: 'invoice-details',
            component: () => import('src/pages/client/InvoiceDetailsPage.vue'),
            meta: {
                title: 'Invoices - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
    ]
}];
